import type { CourseRef, IntakeRef } from '@/entities/Dashboard';

export const formatGrade = (grade: number | null | undefined): string =>
  grade === null || grade === undefined ? '—' : `${Math.round(grade)}/100`;

export { formatPercentOrDash } from '@/shared/lib/utils/formatPercent';

export const formatInactive = (lastSeenAt: string | null | undefined): string => {
  if (!lastSeenAt) return '—';
  const last = new Date(lastSeenAt).getTime();
  if (Number.isNaN(last)) return '—';
  const days = Math.floor((Date.now() - last) / (1000 * 60 * 60 * 24));
  return `${days < 0 ? 0 : days}d`;
};

export const formatStudentSubtitle = (
  course: CourseRef | null | undefined,
  intake: IntakeRef | null | undefined,
): string => [course?.title, intake?.title].filter(Boolean).join(' · ') || '—';

export const formatFullName = (
  user: { firstName: string; lastName: string } | null | undefined,
): string => (user ? `${user.firstName} ${user.lastName}` : '—');
